import React from 'react';
import '../stylesh/PartnersHome.css';

// import azureLogo from '../../../assets/home/azure.svg';
import MicrosoftLogo from '../../../assets/home/microsoft.png';
import gcLogo from '../../../assets/home/gc.svg';
import awsLogo from '../../../assets/home/aws.svg';
import acronisLogo from '../../../assets/home/acronis.svg';
import inuvikaLogo from '../../../assets/home/inuvika1.png';
import virtuozzoLogo from '../../../assets/home/virtuozzo.svg';
import DellTechnologiesLogo from '../../../assets/home/delltechnologies.png';
import Sophos from '../../../assets/home/sophos.png';

const logos = [
  MicrosoftLogo,
  gcLogo,
  awsLogo,
  acronisLogo,  
  DellTechnologiesLogo,
  inuvikaLogo,
  Sophos,
  virtuozzoLogo,
];

const PartnersHome = () => {
  return (
    <div className="partners-container">
      <h1 className="partners-title">Our Partners</h1>

      <div className="logo-marquee">
        <div className="logo-track">
          {/* duplicate logos for seamless scroll */}
          {[...logos, ...logos].map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt="Partner logo"
              className="partner-image"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnersHome;
